import { Expose } from "class-transformer";
import { IsOptional, IsString } from "class-validator";

export class OfficeRole {
  @Expose()
  @IsString()
  displayRoleName!: string;
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsOptional()
  @IsString()
  description!: string;
  @Expose()
  @IsString()
  roleName!: string;
}
